import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Jeff Anders
 * id C5F5CD46-5905-406B-8C0B-7109E8393218
 * name triangle-small-down
 * version: 6.6.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/triangle-small-down.svg
 * tags
 * - Shape 
 */
export const TriangleSmallDownIcon = createSvgIcon(<><path d="M8 9H16L12 16" /></>, 'TriangleSmallDownIcon');
export default TriangleSmallDownIcon